import { Link } from 'react-router-dom';

interface BlogCTAProps {
  ctaType: 'courses' | 'seminar' | 'corporate' | 'brochure';
}

const ctaContent = {
  courses: {
    title: '体系的な学びを始めませんか',
    description: '日本執事アカデミーでは、未経験者からプロ志望者まで、3段階のコースをご用意しています。まずは資料請求で詳細をご確認ください。',
    primaryLabel: '資料請求はこちら（無料）',
    primaryHref: '/brochure',
    secondaryLabel: 'コース一覧を見る',
    secondaryHref: '/courses',
  },
  seminar: {
    title: 'まずは1日、執事の世界を体験しませんか',
    description: '体験講座「執事の作法・入門」では、テーブルマナーや紅茶サービスなど、執事の基本を1日で体感いただけます。参加費は本科申込時に全額充当。',
    primaryLabel: '体験講座を申し込む',
    primaryHref: '/seminar',
    secondaryLabel: '資料請求はこちら（無料）',
    secondaryHref: '/brochure',
  },
  corporate: {
    title: '法人研修のお問い合わせ',
    description: 'ホテル・レジデンス・金融機関など、業種別に最適化した研修プログラムをご提案します。まずはお気軽にご相談ください。',
    primaryLabel: '法人研修について問い合わせる',
    primaryHref: '/corporate',
    secondaryLabel: '資料請求はこちら（無料）',
    secondaryHref: '/brochure',
  },
  brochure: {
    title: 'まずは資料請求から',
    description: '無料の資料でコースの詳細やアカデミーの理念をじっくりご確認いただけます。ご不明な点は個別相談にてお気軽におたずねください。',
    primaryLabel: '資料請求はこちら（無料）',
    primaryHref: '/brochure',
    secondaryLabel: '体験講座を申し込む',
    secondaryHref: '/seminar',
  },
};

export default function BlogCTA({ ctaType }: BlogCTAProps) {
  const content = ctaContent[ctaType];

  return (
    <section className="relative py-16 md:py-24 bg-primary-900 overflow-hidden">
      <div className="absolute top-0 right-0 w-80 h-80 bg-accent-500/[0.03] rounded-full translate-x-1/3 -translate-y-1/3 blur-3xl"></div>

      <div className="relative z-10 max-w-[700px] mx-auto px-8 text-center">
        <p className="text-accent-400/60 text-[13px] tracking-[0.2em] mb-5 font-label">
          NEXT STEP
        </p>
        <h2 className="font-heading text-xl md:text-2xl text-foreground-50 tracking-[0.06em] mb-4">
          {content.title}
        </h2>
        <div className="gold-line mx-auto mb-6"></div>
        <p className="text-[16px] text-foreground-300 leading-relaxed tracking-[0.04em] mb-10 max-w-lg mx-auto">
          {content.description}
        </p>

        <div className="flex flex-col sm:flex-row justify-center gap-4">
          <Link
            to={content.primaryHref}
            className="btn-glow px-8 py-3.5 bg-accent-500/90 hover:bg-accent-500 text-primary-900 text-[15px] tracking-[0.1em] font-medium text-center transition-all duration-300 whitespace-nowrap"
          >
            {content.primaryLabel}
          </Link>
          <Link
            to={content.secondaryHref}
            className="btn-glow px-8 py-3.5 border border-accent-500/50 text-accent-300 hover:text-accent-200 hover:border-accent-400 hover:bg-accent-500/8 text-[15px] tracking-[0.1em] text-center transition-all duration-300 whitespace-nowrap"
          >
            {content.secondaryLabel}
          </Link>
        </div>
      </div>
    </section>
  );
}